/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {ParentBox, relayWrap} from '../../box-utils/ParentBox.react.js';

import {FormattedNumber, FormattedDate, FormattedMessage, IntlShape} from 'react-intl';
import Error from '../system/Error.react.js';
import EmptyContent from '../system/EmptyContent.react';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import MoreLink from '../../box-utils/MoreLink.react';
import PanelColumns from '../system/PanelColumns.react';
import './Firmo.scss';
import {safeJSONparse} from "../../../../common/util/safeJSONparse";

class Firmo extends ParentBox {

    static handlerName = "firmo";

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        return "firmo";
    }

	getServiceName() {
		return "FIRMO";
	}

    computeRow(firmo, idx) {
        let economic = {};
        let showEconomic = true;
        let basic = {};

        if (this.props.isPreview) {
            economic = {
                VYNTOTAL: 9000000,
                HOSPVZUO: 9000,
                PRIDHODN: 900000,
                POCETZAM: 35,
                CASH_FLOW: 9000,
                AKTIVACELK: 90000,
                ROK: (new Date().getFullYear() - 1)
            };
            basic.db_id = '5574617';
			basic.nazev = 'Firma s.r.o.';
        } else {
            if (firmo.economic && firmo.economic.ukazatele && firmo.economic.ukazatele.length > 0) {
                economic = firmo.economic.ukazatele[0];
            } else {
                showEconomic = false;
            }

            basic = firmo;

            if (firmo.basic) { // for backward compatibility of cache. Can be deleted after 2017-05-01
                basic = firmo.basic;
            }
        }

        let percAddedValue = 0;
        if (economic.VYNTOTAL > 0) {
            percAddedValue = economic.PRIDHODN / economic.VYNTOTAL;
        }
        if (percAddedValue < 0) {
            percAddedValue = 0;
        }

        let percProfit = 0;
        if (economic.VYNTOTAL > 0) {
            percProfit = economic.HOSPVZUO / economic.VYNTOTAL;
        }
        if (percProfit < 0) {
            percProfit = 0;
        }

        let output = [];

        output.push(
            <tr key="1"><td className="wrap wholeRow" colSpan="3"><strong className="dativeryValue">{basic.nazev}</strong> (<MoreLink link={"http://www.firmo.cz/cs/spolecnost/" + basic.db_id + "/"} service="Firmo" />)</td></tr>
        );

        if (showEconomic) {
			if (basic.datum_zaniku) {
				output.push(<tr key="2"><td className="wholeRow" colSpan="3"><strong style={{color: 'red'}}><FormattedMessage defaultMessage="Termination date" id="firmo.closedDate" /> <FormattedDate value={basic.datum_zaniku} /></strong></td></tr>);
			}

            if (economic.ROK && economic.ROK < (new Date().getFullYear() - 4)) {
                output.push(<tr key="0-year-warning"><td className="wholeRow" colSpan="3" style={{color: 'red'}}><FormattedMessage defaultMessage="Information is older than 5 years" id="firmo.5yearWarning" /></td></tr>);
            }

            if (economic.VYNTOTAL) {
                output.push(<tr key="3"><td><FormattedMessage defaultMessage="Revenue" id="firmo.revenue" />:</td><td className="r"><span className="dativeryValue"><FormattedNumber value={economic.VYNTOTAL} /></span>&nbsp;<FormattedMessage defaultMessage="thou." id="firmo.thousand" />&nbsp;Kč</td><td></td></tr>);
            }
            if (economic.HOSPVZUO) {
                output.push(<tr key="4"><td><FormattedMessage defaultMessage="Profit" id="firmo.profit" />:</td><td className="r"><span className="dativeryValue"><FormattedNumber value={economic.HOSPVZUO} /></span>&nbsp;<FormattedMessage defaultMessage="thou." id="firmo.thousand" />&nbsp;Kč</td>{percProfit > 0 ? <td><small>(<span className="dativeryValue"><FormattedNumber style="percent" value={percProfit} /></span>)</small></td> : <td></td>}</tr>);
            }
            if (economic.PRIDHODN) {
                output.push(<tr key="5"><td><FormattedMessage defaultMessage="Value added" id="firmo.valueAdded" />:</td><td className="r"><span className="dativeryValue"><FormattedNumber value={economic.PRIDHODN} /></span>&nbsp;<FormattedMessage defaultMessage="thou." id="firmo.thousand" />&nbsp;Kč</td>{percAddedValue > 0 ? <td><small>(<span className="dativeryValue"><FormattedNumber style="percent" value={percAddedValue} /></span>)</small></td> : <td></td>}</tr>);
            }
            if (economic.AKTIVACELK) {
                output.push(<tr key="6"><td><FormattedMessage defaultMessage="Assets" id="firmo.assets" />:</td><td className="r"><span className="dativeryValue"><FormattedNumber value={economic.AKTIVACELK} /></span>&nbsp;<FormattedMessage defaultMessage="thou." id="firmo.thousand" />&nbsp;Kč</td><td></td></tr>);
            }
            if (economic.CASH_FLOW) {
                output.push(<tr key="7"><td><FormattedMessage defaultMessage="Cash flow" id="firmo.cashFlow" />:</td><td className="r"><span className="dativeryValue"><FormattedNumber value={economic.CASH_FLOW} /></span>&nbsp;<FormattedMessage defaultMessage="thou." id="firmo.thousand" />&nbsp;Kč</td><td></td></tr>);
            }
            if (economic.POCETZAM) {
                output.push(<tr key="8"><td><FormattedMessage defaultMessage="Employees" id="firmo.employees" />:</td><td className="r"><span className="dativeryValue">{economic.POCETZAM}</span></td><td></td></tr>);
            }
            if (economic.ROK) {
                output.push(<tr key="9"><td className="wholeRow" colSpan="3"><small>(<FormattedMessage defaultMessage="for year" id="firmo.forYear" /> <span className="dativeryValue">{economic.ROK}</span>)</small></td></tr>);
            }

        } else if (basic.datum_zaniku && basic.datum_vzniku) {
            output.push(<tr key="2"><td className="wholeRow" colSpan="3" style={{color: 'green'}}><strong><FormattedMessage defaultMessage="Established" id="firmo.establishedDateShort" /> <FormattedDate value={basic.datum_vzniku} /></strong> - <strong style={{color: 'red'}}><FormattedMessage defaultMessage="Terminated" id="firmo.closedDateShort" /> <FormattedDate value={basic.datum_zaniku} /></strong></td></tr>);
        } else {
            output.push(<tr key="0"><td className="wholeRow" colSpan="3"><FormattedMessage defaultMessage="No economic data" id="firmo.noEconomicData" /></td></tr>);
            if (basic.datum_vzniku) {
                output.push(<tr key="3"><td className="wholeRow" colSpan="3" style={{color: 'green'}}><strong><FormattedMessage defaultMessage="Established date" id="firmo.establishedDate" /> <FormattedDate value={basic.datum_vzniku} /></strong></td></tr>);
            }
            if (basic.datum_zaniku) {
                output.push(<tr key="2"><td className="wholeRow" colSpan="3"><strong style={{color: 'red'}}><FormattedMessage defaultMessage="Termination date" id="firmo.closedDate" /> <FormattedDate value={basic.datum_zaniku} /></strong></td></tr>);
            }
        }

        return (
            <div key={idx}>
				<table className="table-spaced-columns company-table">
					<tbody>{output}</tbody>
				</table>
			</div>
        );
    }

	static isEmpty(viewWithData) {
		let {addon} = viewWithData;

		if (addon) {
			addon = safeJSONparse(addon);

			if (addon.firmo && Array.isArray(addon.firmo) && addon.firmo.length > 0) {
				return false;
			}
		}

		return true;
	}

    render() {
        try {
            let {addon} = this.props.viewWithData;

            if (addon) {
                addon = safeJSONparse(addon);
                let list;


                if (!Firmo.isEmpty(this.props.viewWithData)) {
                    list = addon.firmo;
                } else if (this.props.isPreview) {
                    list = [{}];
                } else {
                    return (
                        <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                            <EmptyContent />
                        </BoxDecorator>
                    );
                }

                return (
                    <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
						<PanelColumns className="firmo-columns" small>
                            {list.map((firmo, idx) => this.computeRow(firmo, idx))}
						</PanelColumns>
                    </BoxDecorator>
                );
            }

            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <span>?</span>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(Firmo);
